// third-party
import { FormattedMessage } from 'react-intl';

// type
import { NavItemType } from 'types/menu';
import { AccountPermissionLevel, AccountType } from 'types/account';

import { MenuItemIds } from './menu-item-ids';
import Routes from 'routes/RouteNames';

// assets
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';

// icons
const icons = {
  AnalyticsRoundedIcon
};

const advertising: NavItemType = {
  id: MenuItemIds.InternalGroupItemId,
  title: <FormattedMessage id={MenuItemIds.InternalGroupItemId} />,
  type: 'group',
  children: [
    {
      id: MenuItemIds.AdvertisingBannersNavItemId,
      title: <FormattedMessage id={MenuItemIds.AdvertisingBannersNavItemId} />,
      type: 'item',
      icon: icons.AnalyticsRoundedIcon,
      url: `/${Routes.AdvertisingConfiguration}`,
      accountType: AccountType.Customer,
      requiredAccountRole: AccountPermissionLevel.Employee,
      breadcrumbs: false
    }
  ]
};

export default advertising;
